import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ApiService } from '@core/providers/http';
import { EfectivoDocumentoParams } from '@core/models';


@Injectable({
  providedIn: 'root',
})
export class DocumentEfetivoService {

  private readonly endpoint =
    '/api/Documento/Efectivo';

  constructor(
    private readonly apiService: ApiService,
  ) {}

  /**
   * Gera o documento através da API e devolve o Blob.
   *
   * Mantido como fallback e para situações em que
   * precisamos processar o ficheiro no Angular.
   */
  gerarDocumento(
    params: EfectivoDocumentoParams,
  ): Observable<Blob> {

    const httpParams =
      this.criarParametros(params);

    return this.apiService.get<Blob>(
      this.endpoint,
      httpParams,
      {
        responseType: 'blob',
      },
    );
  }

  /**
   * Constrói os parâmetros da API.
   */
  private criarParametros(
    params: EfectivoDocumentoParams,
  ): HttpParams {

    let httpParams =
      new HttpParams();

    if (
      params.PeriodoEnum !== undefined &&
      params.PeriodoEnum !== null
    ) {
      httpParams =
        httpParams.set(
          'PeriodoEnum',
          String(params.PeriodoEnum),
        );
    }

    if (params.DataAdmissaoDe) {
      httpParams =
        httpParams.set(
          'DataAdmissaoDe',
          params.DataAdmissaoDe,
        );
    }

    if (params.DataAdmissaoAte) {
      httpParams =
        httpParams.set(
          'DataAdmissaoAte',
          params.DataAdmissaoAte,
        );
    }

    if (params.DataCriacaoDe) {
      httpParams =
        httpParams.set(
          'DataCriacaoDe',
          params.DataCriacaoDe,
        );
    }

    if (params.DataCriacaoAte) {
      httpParams =
        httpParams.set(
          'DataCriacaoAte',
          params.DataCriacaoAte,
        );
    }

    if (
      params.PostoId !== undefined &&
      params.PostoId !== null
    ) {
      httpParams =
        httpParams.set(
          'PostoId',
          String(params.PostoId),
        );
    }

    if (
      params.ClienteId !== undefined &&
      params.ClienteId !== null
    ) {
      httpParams =
        httpParams.set(
          'ClienteId',
          String(params.ClienteId),
        );
    }

    if (
      params.EstadoEfetivo !== undefined &&
      params.EstadoEfetivo !== null
    ) {
      httpParams =
        httpParams.set(
          'EstadoEfetivo',
          String(params.EstadoEfetivo),
        );
    }

    if (
      params.formatoDocumento !== undefined &&
      params.formatoDocumento !== null
    ) {
      httpParams =
        httpParams.set(
          'formatoDocumento',
          String(params.formatoDocumento),
        );
    }

    return httpParams;
  }

  /**
   * Retorna a URL completa do endpoint.
   *
   * É usada pelo browser para efectuar o download nativo.
   */
  criarUrlDownload(
    params: EfectivoDocumentoParams,
    baseUrl: string,
  ): string {

    const httpParams =
      this.criarParametros(params);

    return `${baseUrl}${this.endpoint}?${httpParams.toString()}`;
  }
}